import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  inputLabel: { color: theme.palette.primary.main },
}));

const ReactHookFormSelect = ({
  name,
  label,
  control,
  defaultValue,
  children,
  required,
  ...props
}) => {
  const classes = useStyles();
  const labelId = `${name}-label`;

  return (
    <FormControl required={required} {...props}>
      <InputLabel className={classes.inputLabel} id={labelId}>
        {label}
      </InputLabel>

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue ?? ""}
        valueName="value"
        onChange={([event]) => event.target.value}
        as={
          <Select
            labelId={labelId}
            label={label}
          >
            {children}
          </Select>
        }
      />

    </FormControl>
  );
};

export default ReactHookFormSelect;
